import { isSupportWxSubscribe, getAcceptTemplates } from '@tencent/wphk-components-wx-subscribe/wx-subscribe-util';
import { computed, ref } from '@vue/composition-api';
import { promSubcWxMsgV2, promQrySubcWxMsg, PromSubcWxMsgV2State } from '@tencent/wphk-act-base-cgi';
import { to, cacheFunc } from '@tencent/wphk-base-utils';

const promQrySubcWxMsgCache = cacheFunc(promQrySubcWxMsg);

const subTplInfo = [{
  id: 'subc.gooddeedday_online_notify',
  tplId: 'sOSGUr4GHK8Y7TxbuS29edmE2sJdJOkH6BZLY1jTpTI',
}];
const chnId = 'good_deed_day';

export type SubTplInfo = {
  /** 用于给后台请求 */
  id: string,
  /** 用于给微信订阅open tag, 模板id在公众号平台配置 */
  tplId: string,
};

/**
 * 根据templateId获得对应的id给后端
 */
const getTmpKeyByIds = (tmpIds: string[], subTplInfo: SubTplInfo[]) => subTplInfo
  .filter(item => tmpIds.includes(item.tplId)).map(item => item.id);

/**
 * 处理订阅成功后续逻辑函数
 */
export function handleSubscribeRes(res) {
  // 把用户接收的模板id发给后端
  const acceptTemplates = getAcceptTemplates(res);
  if (acceptTemplates.length > 0) {
    const tplIds = getTmpKeyByIds(acceptTemplates, subTplInfo);
    // 静默调用即可
    promSubcWxMsgV2({ chnId, tplIds });
  }
  return acceptTemplates.length > 0;
}

/**
 * 检查是否已订阅
 */
export async function checkIfSubscribed(chnId: string, subTplInfo: SubTplInfo[]) {
  const [err, res] = await to(promQrySubcWxMsgCache({ chnId }));
  if (err || !res) {
    return false;
  }
  const subscribedTplList = res.list
    .filter(item => item.subcState === PromSubcWxMsgV2State.HAS_SUBSCRIBE)
    .map(item => item.tplId);
  return subTplInfo.filter(item => subscribedTplList.includes(item.id)).length > 0;
}

export function useSubscribe() {
  const isSubscribed = ref(true);
  // 微信是否支持订阅能力
  const isWxSupport = ref(isSupportWxSubscribe());
  async function subscribeInit() {
    isSubscribed.value = await checkIfSubscribed(chnId, subTplInfo);
  }
  subscribeInit();
  const showWxSubscribe = computed(() => isWxSupport.value && !isSubscribed.value);
  const tplIds = computed(() => subTplInfo.map(item => item.tplId));
  return {
    showWxSubscribe,
    isSubscribed,
    handleSubscribeRes,
    tplIds,
  };
}
